import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _some from "lodash/some";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { Fragment } from 'react';
import classnames from 'classnames';
import { BackgroundProvider } from "../../Background/BackgroundProvider/BackgroundProvider";
import { MatchHeight } from "../../Utility/MatchHeight/MatchHeight";
import { Tab } from "../../Tab/Tab";
import { Theme } from "../../Background/Theme/Theme";
import { defaultThemeContext } from "../../../context/theme.context";
import styles from "./TabsLinkSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TabsLinkSlice = function TabsLinkSlice(_ref) {
  var children = _ref.children,
    tabs = _ref.tabs,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? defaultThemeContext : _ref$theme;
  var checkBgImage = function checkBgImage(child) {
    if (child && _typeof(child) === 'object' && 'props' in child && child.props.background) {
      var background = child.props.background;
      return !!background.mobile && !!background.mobile.image.image2x;
    }
    return false;
  };
  var setPosition = function setPosition(index, count) {
    var offset = count - 1;
    if (offset - index === offset) {
      return 'first';
    } else if (offset - index === 0) {
      return 'last';
    }
  };
  var renderTab = function renderTab(tab, key, theme, tabsCount) {
    tab.position = setPosition(key, tabsCount);
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(Tab, _objectSpread(_objectSpread({}, tab), {}, {
        theme: theme
      }))
    }, key);
  };
  var mobileImage = checkBgImage(children);
  var hasTabFlag = _some(tabs, function (tab) {
    return tab.flag;
  });
  return /*#__PURE__*/_jsxs(Theme, {
    theme: theme,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.heroContainer,
      children: children && /*#__PURE__*/_jsx(BackgroundProvider, {
        className: hasTabFlag ? styles.paddingLg : styles.paddingSm,
        children: children
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classnames({
        [styles.tabsContainer]: true,
        [styles.tabsContainerAlt]: !!mobileImage,
        [styles.tabsHeightLg]: hasTabFlag
      }),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.tabsWrapper,
        role: "tablist",
        children: /*#__PURE__*/_jsx(MatchHeight, {
          children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, key) {
            return renderTab(tab, key, theme, tabs.length);
          })
        })
      })
    })]
  });
};